import React, { useState } from 'react';
import axios from 'axios';
import './css/AdminLoginModal.css';

// const API_URL = 'http://localhost:5410/api'; // adjust prod as needed
const API_URL = 'https://app.polarcut.io/api';

const AdminLoginModal = ({ onSuccess }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!username || !password) return;
    try {
      setLoading(true);
      const res = await axios.post(`${API_URL}/admin/login`, { username, password });
      const { token } = res.data;
      localStorage.setItem('adminJwt', token);
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      setLoading(false);
      if (onSuccess) onSuccess();
    } catch (err) {
      console.error(err);
      setError(err.response?.data?.error || 'Invalid credentials');
      setLoading(false);
    }
  };

  return (
    <div className="wizard-overlay">
      <div className="wizard-modal card" style={{width:'400px'}}>
        <h2>Admin Sign-in</h2>
        {error && <p className="error-msg">{error}</p>}
        <form onSubmit={handleLogin}>
          <label>
            Username
            <input value={username} onChange={(e)=>setUsername(e.target.value)} />
          </label>
          <label>
            Password
            <input type="password" value={password} onChange={(e)=>setPassword(e.target.value)} />
          </label>
          <button className="primary" type="submit" disabled={loading || !username || !password}>Sign in</button>
        </form>
      </div>
    </div>
  );
};

export default AdminLoginModal; 